import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.SUPABASE_URL || '';
const supabaseAnonKey = process.env.SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const clearSupabaseAuthStorage = () => {
  if (typeof window === 'undefined') return;
  try {
    const url = new URL(supabaseUrl);
    const ref = url.hostname.split('.')[0];
    const prefix = `sb-${ref}-`;
    // Supabase auth storage keys live in localStorage, e.g. sb-<ref>-auth-token
    for (let i = window.localStorage.length - 1; i >= 0; i--) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith(prefix)) {
        window.localStorage.removeItem(key);
      }
    }
  } catch {
    // ignore
  }
};
